var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalBase',{attrs:{"title":_vm.format.humanReadableName,"show":_vm.show,"override-style":{
    'max-height': _vm.scssVariables.modalSideOffset,
    'margin-bottom': '0 rem',
    position: 'relative',
  },"override-header-style":{ 'margin-bottom': '1rem' }},on:{"closeClicked":_vm.onCloseClicked},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"preview"},[(_vm.show)?_c('video',{staticClass:"preview-video",attrs:{"autoplay":"","controls":"","preload":""}},[_c('source',{attrs:{"src":_vm.format.videoSignedUrl}})]):_vm._e()])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }